"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyMaxWindow = exports.applyWindowFunction = exports.DateWindowTypes = void 0;
var trimMetricTable_1 = require("./trimMetricTable");
var DateWindowTypes;
(function (DateWindowTypes) {
    DateWindowTypes["LAST_N"] = "last-n";
    DateWindowTypes["SPECIAL"] = "special";
    DateWindowTypes["LATEST_DATA"] = "latest-data";
    DateWindowTypes["CUSTOM"] = "custom";
    DateWindowTypes["DEFINED_START"] = "defined-start";
})(DateWindowTypes = exports.DateWindowTypes || (exports.DateWindowTypes = {}));
var applyWindowFunction = function (table, func) {
    return (0, exports.applyMaxWindow)(func(table));
};
exports.applyWindowFunction = applyWindowFunction;
var applyMaxWindow = function (table) {
    return (0, trimMetricTable_1.trimMetricTable)(table, 1000);
};
exports.applyMaxWindow = applyMaxWindow;
//# sourceMappingURL=core.js.map